import React, { FC } from 'react';
import { Modal } from 'react-responsive-modal';

import styles from './styles/index.module.scss';

interface IModalLayout {
  flag: boolean;
  onClose: () => void;
  size?: string;
  closeOnOverlayClick?: boolean;
}

const ModalLayout: FC<IModalLayout> = ({
  flag,
  onClose,
  children,
  size = 'md',
  closeOnOverlayClick = true,
}) => (
  <Modal
    open={flag}
    center
    onClose={onClose}
    closeOnOverlayClick={closeOnOverlayClick}
    showCloseIcon={closeOnOverlayClick}
    classNames={{
      modal: styles[`modal_${size}`],
      overlay: styles['overlay'],
      closeButton: styles['close-btn'],
      root: styles['modal__root'],
    }}
  >
    {children}
  </Modal>
);

export default ModalLayout;
